import { getApiSLice } from "utils/getApiBaseQuery";

export const authApiSlice = getApiSLice("dev").injectEndpoints({
  tagTypes: ["User"],
  endpoints: (builder) => ({
    authenticate: builder.mutation({
      query: (credentials) => ({
        url: "/LoginApi/Authenticate",
        method: "POST",
        body: {
          ...credentials,
        },
      }),
    }),
    verifyOtp: builder.mutation({
      query: (otpBody) => ({
        url: "/LoginApi/verifyOtp",
        method: "POST",
        body: {
          ...otpBody,
        },
      }),
    }),
    checkIsAuthorized: builder.query({
      query: () => ({
        url: "/LoginApi/CookieCheck",
        method: "GET",
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: "/LoginApi/Logout",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useAuthenticateMutation,
  useVerifyOtpMutation,
  useCheckIsAuthorizedQuery,
  useLogoutMutation,
} = authApiSlice;
